export const environmentNames = Object.freeze({
  DEV: "cdt-dev",
  TEST: "cdt-test",
  PREPROD: "preprod",
  PROD: "prod",
});